export const README_CONTENT = `
<h1>Perilous Writing</h1>
<p>
An <a href="https://obsidian.md">Obsidian</a> plugin which <i>demands</i> writing output,
at the threat of bludgeoning your in-progress work.
</p>

<h2>Try it out!</h2>
<p>
Press either button below to begin a session. Begin writing. If you stop writing for five seconds
all in-session additions will be deleted. You'll be warned after two seconds of inactivity.
</p>
<p>
Only new characters reset (and start) the timer—backspace does not!
</p>

<hr />

<p>
View the full documentation <a href="https://github.com/sameersismail/obsidian-perilous-writing">GitHub</a>.
</p>
`;
